import styled from 'styled-components'
import { ReactComponent as WifiSvg } from '../../assets/icons/amenities-icons/wifi.svg'
import { ReactComponent as TvSvg } from '../../assets/icons/amenities-icons/tv.svg'
import { ReactComponent as PetsSvg } from '../../assets/icons/amenities-icons/pet.svg'
import { ReactComponent as DishwasherSvg } from '../../assets/icons/amenities-icons/dish-washer.svg'
import { ReactComponent as WashingMachineSvg } from '../../assets/icons/amenities-icons/washing-machine.svg'
import { ReactComponent as StairsSvg } from '../../assets/icons/amenities-icons/stairs.svg'
import { ReactComponent as BedroomSvg } from '../../assets/icons/amenities-icons/bedroom-icon.svg'
import { ReactComponent as ShowerSvg } from '../../assets/icons/amenities-icons/shower-icon.svg'
import { ReactComponent as GuestSvg } from '../../assets/icons/amenities-icons/guest-icon.svg'
import { ReactComponent as RoomAreaSvg } from '../../assets/icons/amenities-icons/room-area.svg'
import { ReactComponent as SmokingSvg } from '../../assets/icons/feature-icons/smoking.svg'
import { ReactComponent as AlertTriangleSvg } from '../../assets/icons/alert-triangle.svg'
import { ReactComponent as CheckedCircleSvg } from '../../assets/icons/checked-circle.svg'
import { ReactComponent as WarningTriangleSvg } from '../../assets/icons/warning-triangle.svg'
import { ReactComponent as ElevatorSvg } from '../../assets/icons/elevator.svg'
import { ReactComponent as GroundLevelSvg } from '../../assets/icons/ground-level.svg'
import { ReactComponent as SaunaSvg } from '../../assets/icons/sauna.svg'
import { ReactComponent as WheelChairSvg } from '../../assets/icons/wheelchair.svg'
import { ReactComponent as PoolSvg } from '../../assets/icons/pool.svg'
import { ReactComponent as ChargingStationSvg } from '../../assets/icons/charging-station.svg'

const Styled = (Svg: React.FC<React.SVGProps<SVGSVGElement>>) => styled(Svg)``

const IconMapping: Record<string, ReturnType<typeof Styled>> = {
    wifi: Styled(WifiSvg),
    tv: Styled(TvSvg),
    television: Styled(TvSvg),
    smoking: Styled(SmokingSvg),
    pets: Styled(PetsSvg),
    dishwasher: Styled(DishwasherSvg),
    washingMachine: Styled(WashingMachineSvg),
    stairs: Styled(StairsSvg),
    groundLevel: Styled(GroundLevelSvg),
    elevator: Styled(ElevatorSvg),
    sauna: Styled(SaunaSvg),
    alertTriangle: Styled(AlertTriangleSvg),
    checkedCircle: Styled(CheckedCircleSvg),
    warningTriangle: Styled(WarningTriangleSvg),
    barrierFree: Styled(WheelChairSvg),
    wheelChairWithBarrier: Styled(WheelChairSvg),
    pool: Styled(PoolSvg),
    chargingStation: Styled(ChargingStationSvg),
    beds: Styled(BedroomSvg),
    bathrooms: Styled(ShowerSvg),
    guests: Styled(GuestSvg),
    area: Styled(RoomAreaSvg),
}

export default IconMapping
